import {
  GridTableBody,
  TableCellAttribute,
  TableConstructorData,
  TableRowData,
  UserTableConstructorInfo,
} from 'src/app/interfaces/tables.interfaces';
import { AccountStatus } from 'src/app/swagger-api';
import { CellType, ColumnTypes } from 'src/app/views/grid-user-list/grid-table.enum';

export const tableBodyMock: GridTableBody[] = [
  {
    entityId: 'entityId',
    actorId: 'actorId',
    user: {
      user_id: 'userId',
      displayed_name: 'JohnSmith',
      is_admin: false,
      account_status: AccountStatus.ACTIVE,
    },
    created: '12/07/1998',
    manage: {
      status: true,
      reason: null,
    },
  },
  {
    entityId: 'entityId1',
    actorId: 'actorId1',
    user: {
      user_id: 'userId_1',
      displayed_name: 'SmithJohn',
      is_admin: false,
      account_status: AccountStatus.ACTIVE,
    },
    created: '12/07/1998',
    manage: {
      status: false,
      reason: null,
    },
  },
  {
    entityId: 'entityId2',
    actorId: 'actorId2',
    user: {
      user_id: 'userId_2',
      displayed_name: 'AnotherUser',
      is_admin: false,
      account_status: AccountStatus.ACTIVE,
    },
    created: '12/07/1998',
    manage: {
      status: true,
      reason: null,
    },
  },
];

export const usersTableHeaders: ColumnTypes[] = [ColumnTypes.USER, ColumnTypes.DATE, ColumnTypes.MANAGE];
export const entitiesTableHeaders: ColumnTypes[] = [ColumnTypes.DATE, ColumnTypes.MANAGE];

export function filterTableBody(field: TableRowData[]): GridTableBody[] {
  return field.map((item: TableRowData) => {
    if (item.user) {
      return {
        entityId: item.entityId,
        actorId: item.actorId,
        user: item.user,
        created: item.created || null,
        manage: item.manage || null,
      };
    }

    if (item.entity) {
      return {
        entityId: item.entityId,
        actorId: item.actorId,
        entity: item.entity,
        link: item.link,
        created: item.created || null,
        manage: item.manage || null,
      };
    }

    return null;
  });
}

export function filterDataForUserTable(field: TableConstructorData): UserTableConstructorInfo {
  const attr: TableCellAttribute = field.cellAttributes.find(
    (item: TableCellAttribute) => item.key === CellType.REMOVE || item.key === CellType.MANAGE,
  );
  return {
    header: usersTableHeaders,
    body: filterTableBody(field.data.tbody),
    attribute: attr ? attr : null,
  };
}

export function filterDataForEntityTable(
  field: TableConstructorData,
  entityType: ColumnTypes,
): UserTableConstructorInfo {
  const attr: TableCellAttribute = field.cellAttributes.find(
    (item: TableCellAttribute) => item.key === CellType.REMOVE || item.key === CellType.MANAGE,
  );
  return {
    header: [entityType, ...entitiesTableHeaders],
    body: filterTableBody(field.data.tbody),
    attribute: attr ? attr : null,
  };
}

export const builTableElementTestId: (prefix: string, rowIndex: number, cellIndex: number) => string = (
  prefix: string,
  rowIndex: number,
  cellIndex: number,
) => {
  return `${prefix}-${rowIndex.toString()}-${cellIndex.toString()}`;
};
